/*  
  TODO: TO BE DEPRECATED: This file doesn't seem to be in use anymore for Flights team.
  If packages team doesn't use this, we can remove it
*/
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Text, Flex, getPaletteColor, Absolute, Relative } from 'pcln-design-system'
import DisplayPrice from '../PriceBox/DisplayPrice'
import FormattedIconRow from '../FormattedIcon/FormattedIconRow'

const ShelfOptionWrapper = styled(Relative)`
  border: solid ${getPaletteColor('border.base')} 1px;
  cursor: pointer;
  &:hover {
    border: solid ${getPaletteColor('border.dark')} 1px;
    transition: border-color ${(props) => props.theme.duration.slowest};
  }
`

const BorderExtender = styled(Absolute)`
  height: 100%;
  ${ShelfOptionWrapper}:hover & {
    left: -2px;
  }
`

const ShelfOption = ({
  fareBrandName,
  price,
  borderLeft,
  borderRadiusOverride,
  handleClick,
  carryOnAvailability,
  seatAvailability,
  token,
  checkedBagAvailability,
}) => (
  <ShelfOptionWrapper
    width={'100%'}
    borderLeft={borderLeft}
    borderRadiusOverride={borderRadiusOverride}
    onClick={() => {
      handleClick({ token, cabinNames: [fareBrandName] })
    }}
    borderRadius={borderRadiusOverride ? borderRadiusOverride : 'none'}
    rounded='topRight'
  >
    {!borderLeft && <BorderExtender top={0} left={'-1px'} bg='background.lightest' width={'1px'} />}
    <Absolute mb={'20px'} width={'100%'} top={0} left={0} p={2}>
      <Text align='center' caps bold fontSize={'10px'} lineHeight={'12px'}>
        {fareBrandName}
      </Text>
    </Absolute>
    <Box pt={'35px'}>
      <DisplayPrice data-autobot-element='display-price' color={'secondary.base'} price={price} isShelf />
    </Box>
    <Box mb={'40px'}>
      <Text align='center' color='text.light' fontSize={0}>
        per person
      </Text>
    </Box>
    <Absolute bottom={8} left={0} width={'100%'}>
      <Flex justifyContent={'center'}>
        <FormattedIconRow
          checkedBagAvailability={checkedBagAvailability}
          seatAvailability={seatAvailability}
          carryOnAvailability={carryOnAvailability}
        />
      </Flex>
    </Absolute>
  </ShelfOptionWrapper>
)

ShelfOption.propTypes = {
  fareBrandName: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  borderLeft: PropTypes.bool,
  borderRadiusOverride: PropTypes.bool,
  carryOnAvailability: PropTypes.bool,
  seatAvailability: PropTypes.bool,
  checkedBagAvailability: PropTypes.bool,
  token: PropTypes.string,
}

export default ShelfOption
